import React from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { toggleSpinner } from 'apps/auth/actions/appAction';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { amplitudeLogout } from 'apps/auth/components/utils/AmplitudeUtils';
import { LOGOUT_COMPLETED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { FROM } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { LOGIN, LOGOUT } from 'apps/auth/constants/UrlConstants';
import { logWarn } from 'apps/auth/helpers/clientLogger';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const LogoutPopup = (props) => {
    const { sideBarMenu_logout: logoutTitle } = usePageMessages();

    const logout = (e) => {
        e.preventDefault();
        props.toggleSpinner(true);
        props.popupRef.current?.close();
        fetch('/logout', { method: 'GET' })
            .then((response) => {
                if (response.ok) {
                    if (props.fromFlow) {
                        amplitude.getInstance().logEvent(LOGOUT_COMPLETED, { [FROM]: props.fromFlow });
                    }
                    window.history.pushState(null, '', LOGIN);
                    window.location.replace(LOGIN);
                    amplitudeLogout();
                }
            })
            .catch((error) => {
                logWarn(error);
                props.toggleSpinner(false);
                return null;
            });
        props.removeErrorMessage?.();
    };

    return (
        <SimplePopup withoutBorder popupRef={props.popupRef}>
            <PopupButton href={LOGOUT} iconName="power" text={props.logout || logoutTitle} onClick={(e) => logout(e)} />
        </SimplePopup>
    );
};
export default connect(null, { toggleSpinner })(LogoutPopup);
